function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.35 4.395l5.549 6.474a1.45 1.45 0 002.202 0l5.55-6.474A1.45 1.45 0 0012.549 2H1.451A1.45 1.45 0 00.349 4.395z",
  fill: "currentColor"
});

var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzQ5MjA4IDQuMzk0NTRMNS44OTg2NiAxMC44Njg5QzYuNDIwMDEgMTEuNDc3MSA3LjMzNTc0IDExLjU0NzYgNy45NDM5OSAxMS4wMjYyQzguMDAwMzggMTAuOTc3OSA4LjA1Mjk4IDEwLjkyNTMgOC4xMDEzMiAxMC44Njg5TDEzLjY1MDggNC4zOTQ1NEMxNC4xNzIxIDMuNzg2MjkgMTQuMTAxNyAyLjg3MDU2IDEzLjQ5MzQgMi4zNDkyMUMxMy4yMzA1IDIuMTIzODYgMTIuODk1NyAyIDEyLjU0OTQgMkwxLjQ1MDU0IDJDMC42NDk0MjkgMiAwIDIuNjQ5NDMgMCAzLjQ1MDU0QzAgMy43OTY4IDAuMTIzODY1IDQuMTMxNjQgMC4zNDkyMDggNC4zOTQ1NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgDropdown as ReactComponent };